/* eslint-disable */
//tslint:disable

import { IAgentSchema } from '../agent/AgentSchema';
import { IBargainTermsForDesktopSchema } from './BargainTermsForDesktopSchema';
import { ICommercialInfoSchema } from './CommercialInfoSchema';
import { IFlatInfoSchema } from './FlatInfoSchema';
import { IGeoForDesktopSchema } from './GeoForDesktopSchema';
import { IJKInfoSchema } from './JKInfoSchema';
import { ISuburbanInfoSchema } from './SuburbanInfoSchema';

export interface IFavoriteEntityForDesktopSchema {
  /** Информация об агенте **/
  agentInfo?: IAgentSchema | null;
  /** Информация о цене **/
  bargainTerms: IBargainTermsForDesktopSchema;
  /** ИД категории для определния типа жалоб **/
  categoryComplaintId?: number | null;
  /** Информация о коммерческой недвижимости **/
  commercialInfo?: ICommercialInfoSchema | null;
  /** Тип сделки **/
  dealType: EDealType;
  /** Дата когда объявление удалится, только для снятых с публикаци **/
  deleteDate?: string | null;
  /** Описание **/
  description?: string | null;
  /** Cian ID объявления **/
  entityCianId?: number | null;
  /** Realty Id объекта (объявка/ЖК) **/
  entityId: number;
  /** Тип объекта (объявка/ЖК) **/
  entityType: EEntityType;
  /** Информация о жилой недвижимости **/
  flatInfo?: IFlatInfoSchema | null;
  /** Ссылка на объект **/
  fullUrl: string;
  /** Информация о Гео **/
  geo: IGeoForDesktopSchema;
  /** Информация о ЖК **/
  jkInfo?: IJKInfoSchema | null;
  /** Текст заметки **/
  note?: string | null;
  /** Телефон **/
  phone?: string | null;
  /** URL исходного изображения **/
  photoFullUrl?: string | null;
  /** Показывать ли предупреждение о недопустимости предоплаты **/
  showWarningMessage?: boolean | null;
  /** Статус **/
  status?: EStatus | null;
  /** Информация о загородной недвижимости **/
  suburbanInfo?: ISuburbanInfoSchema | null;
  /** Заголовок объекта **/
  title: string;
}

export enum EDealType {
  /** Аренда **/
  Rent = 'rent',
  /** Продажа **/
  Sale = 'sale',
}
export enum EEntityType {
  /** Коммерческая **/
  Commercial = 'commercial',
  /** ЖК **/
  Newbuilding = 'newbuilding',
  /** Жилая **/
  Residential = 'residential',
  /** Загородка **/
  Suburban = 'suburban',
}
export enum EStatus {
  /** Заблокировано **/
  Blocked = 'blocked',
  /** Деактивировано **/
  Deactivated = 'deactivated',
  /** Удалено **/
  Deleted = 'deleted',
  /** Черновик **/
  Draft = 'draft',
  /** Склеен с другим ЖК **/
  Merge = 'merge',
  /** Промодерировано **/
  Moderate = 'moderate',
  /** Новый, создан пользователем **/
  New = 'new',
  /** Опубликовано **/
  Published = 'published',
  /** Отклонено **/
  Refused = 'refused',
  /** Удалено модератором **/
  RemovedByModerator = 'removedByModerator',
  /** Продано **/
  Sold = 'sold',
}
